import {
  Box,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Autocomplete,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import module from "./FormSelfInformation.module.css";
import { useContext, useState } from "react";
import GridItemText from "./GridItemText";
import AddressInputs from "./AddressInputs";
import BirthdaySelect from "./BirthdaySelect";
import {
  basicAttribute,
  nationalCodeList,
} from "../../../config/rewardSetting";
import { RewardSettingContext } from "../../../contexts/RewardSettingContext";

const FormSelfInformation = () => {
  const { user, settingParam, handleNationalCode, basicInfo, setBasicInfo } =
    useContext(RewardSettingContext);
  const isSelectedManualInput = () => {
    if (!user) {
      return false;
    }
    if (!user.attributes) {
      return false;
    }
    if (!user.attributes["custom:manual_family_name"]) {
      return false;
    }
    return true;
  }
  const isFinishManualEKyc = () => {
    if (!user) return false;
    if (!user.attributes) return false;
    return user.attributes["custom:finish_manual_ekyc"];
  }

  const [isSelectManualInput, setIsSelectManualInput] = useState(isSelectedManualInput());

  const getCustomAttribute = (key) => {
    if (!user) {
      return null;
    }
    if (!user.attributes) {
      return null;
    }
    if (key === "email") {
      return user.attributes.email;
    }
    if (user.attributes.birthdate) {
      if (key === "birth_year") {
        return Number(user.attributes.birthdate.split("-")[0]);
      }
      if (key === "birth_month") {
        return Number(user.attributes.birthdate.split("-")[1]);
      }
      if (key === "birth_day") {
        return Number(user.attributes.birthdate.split("-")[2]);
      }
    }
    if (
      key === "phone_number" &&
      settingParam.nationalCode &&
      user.attributes.phone_number
    ) {
      return user.attributes.phone_number.slice(
        settingParam.nationalCode.length
      );
    }
    if (basicAttribute.includes(key)) {
      return user.attributes[key];
    }
    return user.attributes[`custom:${key}`];
  };

  const handleManualInputName = (value) => {
    setIsSelectManualInput(value);
  }

  const handleSelect = (event) => {
    const { value } = event.target;
    const isManual = value === "manual";
    handleManualInputName(isManual);
  }

  return (
    <>
      <Grid container spacing={2}>
        <GridItemText
          label="姓(自動入力)"
          name={"family_name"}
          defaultValue={getCustomAttribute("family_name")}
          placeholder={"例：山田"}
          disabled
        />
        <GridItemText
          label="名(自動入力)"
          name={"given_name"}
          defaultValue={getCustomAttribute("given_name")}
          placeholder={"例：太郎"}
          disabled
        />
      </Grid>
      {!isFinishManualEKyc() && (
        <FormControl sx={{ width: "100%", paddingLeft: "32px", marginBottom: "24px" }}>
          <RadioGroup
            aria-labelledby="select-address-input-way"
            defaultValue="ocr"
            name="group-select-address-input-way"
            value={isSelectManualInput ? "manual" : "ocr"}
            onChange={handleSelect}
          >
            <FormControlLabel value="ocr" control={<Radio />} label="読み取った氏名を使用" />
            <FormControlLabel value="manual" control={<Radio />} label="別の氏名を入力" />
          </RadioGroup>
        </FormControl>
      )}
      {isSelectManualInput && (
        <Grid container spacing={2}>
          <GridItemText
            label="姓"
            name={"manual_family_name"}
            defaultValue={getCustomAttribute("manual_family_name")}
            placeholder={"例：山田"}
          />
          <GridItemText
            label="名"
            name={"manual_given_name"}
            defaultValue={getCustomAttribute("manual_given_name")}
            placeholder={"例：太郎"}
          />
        </Grid>
      )}
      <Grid container spacing={2}>
        <GridItemText
          label="セイ"
          placeholder={"例：ヤマダ"}
          name={"family_name_kana"}
          defaultValue={basicInfo.familyNameKana !== "" ? basicInfo.familyNameKana : getCustomAttribute("family_name_kana")}
          helperText={isSelectManualInput ? "証明書とは別の姓(セイ)を入力ください" : null}
          onBlur={(e) => setBasicInfo({ ...basicInfo, familyNameKana: e.target.value })}
        />
        <GridItemText
          label="メイ"
          placeholder={"例：タロウ"}
          name={"given_name_kana"}
          defaultValue={basicInfo.givenNameKana !== "" ? basicInfo.givenNameKana : getCustomAttribute("given_name_kana")}
          helperText={isSelectManualInput ? "証明書とは別の名(メイ)を入力ください" : null}
          onBlur={(e) => setBasicInfo({ ...basicInfo, givenNameKana: e.target.value })}
        />
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={4} sx={{ textAlign: "left", marginBottom: "24px" }}>
          <label>国コード</label>
          <span className={module.labelRequired}>*</span>
          <Autocomplete
            disablePortal
            id="national_code"
            name="national_code"
            sx={{ marginTop: "8px" }}
            options={nationalCodeList}
            value={settingParam.nationalCode}
            renderInput={(params) => <TextField {...params} />}
            onChange={handleNationalCode}
          />
        </Grid>
        <GridItemText
          xs={8}
          label="お電話番号"
          placeholder={"例：08000123456"}
          type={"phone_number"}
          name={"phone_number"}
          defaultValue={basicInfo.phoneNumber !== "" ? basicInfo.phoneNumber : getCustomAttribute("phone_number")}
          onBlur={(e) => setBasicInfo({ ...basicInfo, phoneNumber: e.target.value })}
        />
      </Grid>

      <FormControl fullWidth sx={{ marginBottom: "24px", textAlign: "left" }}>
        <Box sx={{ textAlign: "left" }}>
          <label className={module.label}>{"性別"}</label>
          <span className={module.labelRequired}>*</span>
        </Box>
        <Select
          id="gender-select"
          name="gender"
          defaultValue={basicInfo.gender !== "" ? basicInfo.gender : getCustomAttribute("gender")}
          onBlur={(e) => {
            setBasicInfo({ ...basicInfo, gender: e.target.value });
          }}
        >
          <MenuItem value={"title"} disabled>
            性別
          </MenuItem>
          <MenuItem value={"man"}>{basicInfo.gender === "man" ? "男" : "男"}</MenuItem>
          <MenuItem value={"woman"}>{basicInfo.gender === "woman" ? "女" : "女"}</MenuItem>
          <MenuItem value={"other"}>{basicInfo.gender === "other" ? "回答しない" : "回答しない"}</MenuItem>
        </Select>
      </FormControl>
      <BirthdaySelect getCustomAttribute={getCustomAttribute} />
      <AddressInputs getCustomAttribute={getCustomAttribute} />
      <GridItemText
        label="メールアドレス(自動入力)"
        placeholder={"例：sample@nosh.jp"}
        value={getCustomAttribute("email")}
        type={"email"}
        name={"email"}
        disabled
      />
    </>
  );
};

export default FormSelfInformation;
